module.exports = __webpack_public_path__ + "img/227.5858298c.jpg";